module.exports = __webpack_public_path__ + "img/filter-icon.8c7d4eb9.svg";